export enum UserRole {
  ORGANISATION_MANAGER = "Organisation manager",
  CAREHOME_MANAGER = "Care home management",
  NURSING_PROFESSIONAL = "Nursing professional"
}

export const ALLOWED_COCKPIT_ROLES = [
  UserRole.ORGANISATION_MANAGER,
  UserRole.CAREHOME_MANAGER,
] as const;

export const isCockpitAllowedRole = (role: string): boolean =>
  ALLOWED_COCKPIT_ROLES.includes(
    role as (typeof ALLOWED_COCKPIT_ROLES)[number]
  ); 